export const SELECTING_SITE_ID = 'SELECTING_SITE_ID';
export const SELECTING_DIRECTORY = 'SELECTING_DIRECTORY';
export const SELECTING_ELEMENTS = 'SELECTING_ELEMENTS';
export const SELECTING_SERVER_ID = 'SELECTING_SERVER_ID';
